/**
 * Opdrachten aan de reactietegel van buitenaf (sessie 46, B1 en B2).
 *
 * Het klantblok (Bel, Mail, WhatsApp) en "Nieuw bericht" staan niet in de
 * tegel, maar moeten hem wel kunnen openen: in de juiste stand, met de
 * cursor in het tekstveld, of met het belvenster open. Zelfde vorm als
 * `antwoordBrug`: een kleine store zonder React, omdat de tegel en de
 * knoppen in verschillende takken van de boom staan.
 *
 * Een opdracht hoort bij één zaak. De tegel van een andere zaak negeert
 * hem; zo opent een klik op een kaart die nog laadt nooit de tegel van de
 * vorige kaart.
 */

export type TegelOpdracht =
  | {
      soort: "open";
      zaakId: string;
      aan?: string | null;
      /** Sessie 47 (5b): een tekst die Sanne klaarzette (Retour afronden). */
      tekst?: string | null;
      onderwerp?: string | null;
    }
  | {
      soort: "bel";
      zaakId: string | null;
      klantId: string | null;
      nummer?: string | null;
      /** Sessie 47 (9d): waar de knop stond; komt op de tijdlijn van het gesprek. */
      bron?: string;
    };

type Luisteraar = (opdracht: TegelOpdracht) => void;

const luisteraars = new Set<Luisteraar>();
let wachtend: TegelOpdracht | null = null;

/** Geef de tegel een opdracht. Staat de tegel nog niet, dan wacht hij. */
export function stuurNaarTegel(opdracht: TegelOpdracht): void {
  wachtend = opdracht;
  for (const luisteraar of luisteraars) {
    try {
      luisteraar(opdracht);
    } catch {
      // Een melding, geen handeling: één kapotte luisteraar stopt de rest niet.
    }
  }
}

/** Haal de wachtende opdracht voor deze zaak op en leeg hem. */
export function neemOpdracht(zaakId: string | null): TegelOpdracht | null {
  if (wachtend === null) return null;
  if (wachtend.zaakId !== null && wachtend.zaakId !== zaakId) return null;
  const opdracht = wachtend;
  wachtend = null;
  return opdracht;
}

export function luisterNaarTegel(luisteraar: Luisteraar): () => void {
  luisteraars.add(luisteraar);
  return () => {
    luisteraars.delete(luisteraar);
  };
}

/** Alleen voor toetsen. */
export function leegTegelBrug(): void {
  wachtend = null;
}
